import React from 'react';
import { useStaticQuery, graphql, navigate } from 'gatsby';
import { gsap } from 'gsap';
import { useTranslate } from 'soluble-gatsby-source';
import { Heading } from 'aplazame-design-system';
import style from './style.module.scss';


function Calculator(props) {

    const _ = useTranslate();
    const data = useStaticQuery(graphql`
        query {
            settings: datoCmsSetting {
                calculator
                taePercentage
                ctaUrlCalculator {
                    slug
                }
            }
        }
    `);

    const json = JSON.parse(data.settings.calculator);
    const tae = data.settings.taePercentage;

    const tlRevealQuotasMobile = React.useRef();
    const wrapperRevealQuotasMobile = React.useRef();
    const wrapperCalculateQuotasMobile = React.useRef();
    const wrapperFooter = React.useRef();


    const [month, setMonth] = React.useState(1);
    const [monthFake, setMonthFake] = React.useState(3);
    const [money, setMoney] = React.useState(100);
    const [touch, setTouch] = React.useState(false);
    const [moneyFake, setMoneyFake] = React.useState(100);

    const [moneyFocus, setMoneyFocus] = React.useState(false);
    const [monthFocus, setMonthFocus] = React.useState(false);


    React.useEffect(() => {
        tlRevealQuotasMobile.current = gsap
            .timeline({ paused: true })
            .to(wrapperCalculateQuotasMobile.current, { autoAlpha: 0 })
            .to(wrapperFooter.current, { autoAlpha: 0 }, "<")
            .set(wrapperCalculateQuotasMobile.current, { display: 'none' })
            .set(wrapperFooter.current, { display: 'none' }, "<")
            .set(wrapperRevealQuotasMobile.current, { display: 'block' })
            .to(wrapperRevealQuotasMobile.current, {
                autoAlpha: 1,
            });

        document.querySelectorAll(".apz-input-range").forEach(function (ctrl) {
            const el = ctrl.querySelector('input');
            el.oninput = function () {
                // colorize step options
                ctrl.querySelectorAll("option").forEach(function (opt) {
                    if (opt.value <= el.valueAsNumber)
                        opt.style.backgroundColor = '#0053FF';
                    else
                        opt.style.backgroundColor = '#A7A9AC';
                });
                // colorize before and after
                var valPercent = (el.valueAsNumber - parseInt(el.min)) / (parseInt(el.max) - parseInt(el.min));
                var style = 'background-image: -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(' +
                    valPercent + ', #0053FF), color-stop(' +
                    valPercent + ', #ddd));';
                el.style = style;
            };
            el.oninput();
        });

        window.onresize = function () {
            document.querySelectorAll(".__range").forEach(function (ctrl) {
                var el = ctrl.querySelector('input');
                el.oninput();
            });
        };

        return () => {
            tlRevealQuotasMobile.current.kill();
        };
    }, []);

    return (
        <>
            <div className={style['embla__back']}>

                <div>
                    <div className={style.form}>
                        <Heading
                            tag={'h3'}
                            className={`${[style.headingSlide].join(' ')} ${style.back}`}
                        >
                            {_['calculator.heading']?.text}
                        </Heading>
                        <p dangerouslySetInnerHTML={{ __html: _['calculator.subheading']?.text }} className={style.headerText} />
                        <label>
                            <svg
                                width="34"
                                height="39"
                                viewBox="0 0 34 39"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="17" cy="19" r="17" fill="#231F20" />
                                <path
                                    d="M16.5462 25V16.136L14.7062 16.568V15L17.4102 13.8H18.6742V25H16.5462Z"
                                    fill="white"
                                />
                            </svg>
                            <span>Quanto pretende financiar?</span>
                        </label>

                        <input aria-label={`Montante a financiar. O montante deve estar entre 100 e 2500 euros. Valor atual: ${moneyFake} €`} type='text' readOnly value={`${moneyFake} €`}></input>


                        <div className={`apz-input-range apz-input-range--btn ${style["__range"]} ${style["__range-step"]}`}>
                            <input
                                onFocus={() => setMoneyFocus(true)}
                                onBlur={() => setMoneyFocus(false)}
                                // aria-valuetext={
                                //     { 1: "100 €", 2: "200 €", 3: "300 €", 4: "400 €", 5: "500 €", 6: "600 €", 7: "700 €", 8: "800 €", 9: "900 €", 10: "1000 €", 11: "1100 €", 12: "1200 €", 13: "1300 €", 14: "1400 €", 15: "1500 €", 16: "1600 €", 17: "1700 €", 18: "1800 €", 19: "1900 €", 20: "2000 €", 21: "2100 €", 22: "2200 €", 23: "2300 €", 24: "2400 €", 25: "2500 €" }[money]
                                // }
                                type="range"
                                min="100"
                                max="2500"
                                step="100"
                                value={money}
                                aria-label={`Montante a financiar. O montante deve estar entre 100 e 2500 euros. Valor atual: ${moneyFake} €`}
                                // max="25"
                                // min="1"
                                // step="1"
                                aria-valuemin="100"
                                aria-valuemax="2500"
                                aria-valuenow={money}
                                aria-valuetext={`Importe seleccionado: ${money} €`}

                                list="ticks1" onChange={(e) => {
                                    setTouch(true);
                                    // const mappedValues = { 1: 100, 2: 200, 3: 300, 4: 400, 5: 500, 6: 600, 7: 700, 8: 800, 9: 900, 10: 1000, 11: 1100, 12: 1200, 13: 1300, 14: 1400, 15: 1500, 16: 1600, 17: 1700, 18: 1800, 19: 1900, 20: 2000, 21: 2100, 22: 2200, 23: 2300, 24: 2400, 25: 2500 };
                                    // setMoneyFake(mappedValues[e.target.value]);
                                    setMoneyFake(e.target.value);
                                    setMoney(e.target.value);
                                }}
                            />

                            {moneyFocus &&
                                <div className={style.rangeValueContainer}>
                                    <div className={style.rangeValueItem} style={{ left: `calc(${((money - 100) / 2400) * 100}% - ${35 + ((money - 100) / 2400) * 30}px)` }}>
                                        <div className={style.rangeLabel}>
                                            <span>{`${moneyFake} €`}</span>
                                        </div>
                                    </div>
                                </div>
                            }

                            <datalist id="ticks1">
                                <option value="100"></option>
                                <option value="200"></option>
                                <option value="300"></option>
                                <option value="400"></option>
                                <option value="500"></option>
                                <option value="600"></option>
                                <option value="700"></option>
                                <option value="800"></option>
                                <option value="900"></option>
                                <option value="1000"></option>
                                <option value="1100"></option>
                                <option value="1200"></option>
                                <option value="1300"></option>
                                <option value="1400"></option>
                                <option value="1500"></option>
                                <option value="1600"></option>
                                <option value="1700"></option>
                                <option value="1800"></option>
                                <option value="1900"></option>
                                <option value="2000"></option>
                                <option value="2100"></option>
                                <option value="2200"></option>
                                <option value="2300"></option>
                                <option value="2400"></option>
                                <option value="2500"></option>
                            </datalist>
                        </div>

                        <div className={style.indicator}>
                            <span aria-hidden="true">100 €</span>
                            <span aria-hidden="true">2.500 €</span>
                        </div>

                        <div className={`${style.clearfix}`}></div>

                        <label className={style.separator}>
                            <svg
                                width="34"
                                height="39"
                                viewBox="0 0 34 39"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="17" cy="19" r="17" fill="#231F20" />
                                <path
                                    d="M13.2457 25V23.512C13.9284 22.9467 14.5897 22.3867 15.2297 21.832C15.8804 21.2773 16.4564 20.728 16.9577 20.184C17.4697 19.64 17.875 19.112 18.1737 18.6C18.483 18.0773 18.6377 17.5707 18.6377 17.08C18.6377 16.6213 18.5097 16.216 18.2537 15.864C18.0084 15.512 17.5977 15.336 17.0217 15.336C16.435 15.336 15.9924 15.528 15.6937 15.912C15.395 16.296 15.2457 16.76 15.2457 17.304H13.2617C13.283 16.4827 13.4644 15.8 13.8057 15.256C14.147 14.7013 14.6004 14.2907 15.1657 14.024C15.731 13.7467 16.3657 13.608 17.0697 13.608C18.211 13.608 19.0964 13.9227 19.7257 14.552C20.3657 15.1707 20.6857 15.976 20.6857 16.968C20.6857 17.5867 20.5417 18.1893 20.2537 18.776C19.9764 19.3627 19.6084 19.928 19.1497 20.472C18.691 21.016 18.195 21.528 17.6617 22.008C17.1284 22.4773 16.611 22.9147 16.1097 23.32H20.9577V25H13.2457Z"
                                    fill="white"
                                />
                            </svg>

                            <span>Durante quanto tempo:</span>
                        </label>

                        <input
                            aria-label={`Prazo selecionado: ${monthFake} meses. O prazo deve estar entre 3 e 36 meses.`}
                            className={style.inputMonths}
                            type='text'
                            readOnly
                            value={`${monthFake} meses`}></input>


                        <div className={`apz-input-range apz-input-range--btn ${style["__range"]} ${style["__range-step"]}`}>
                            <input
                                onFocus={() => setMonthFocus(true)}
                                onBlur={() => setMonthFocus(false)}
                                aria-label={`Duração do empréstimo. O prazo deve estar entre 3 e 36 meses. Valor atual: ${monthFake} meses.`}
                                aria-valuemin="3"
                                aria-valuemax="36"
                                aria-valuenow={month}
                                aria-valuetext={
                                    { 1: "Prazo selecionado: 3 meses", 2: "Prazo selecionado: 6 meses", 3: "Prazo selecionado: 9 meses", 4: "Prazo selecionado: 12 meses", 5: "Prazo selecionado: 24 meses", 6: "Prazo selecionado: 36 meses" }[month]
                                }
                                value={month}
                                type="range"
                                max="6"
                                min="1"
                                step="1"
                                list="ticks2"
                                onChange={(e) => {
                                    setTouch(true);
                                    const mappedValues = { 1: 3, 2: 6, 3: 9, 4: 12, 5: 24, 6: 36 };
                                    setMonthFake(mappedValues[e.target.value]);
                                    setMonth(e.target.value);
                                }}
                            />
                            {monthFocus &&
                                <div className={style.rangeValueContainer}>
                                    <div className={style.rangeValueItem} style={{ left: `calc(${((month - 1) / 5) * 100}% - ${35 + ((month - 1) / 5) * 30}px)` }}>
                                        <div className={style.rangeLabel}>
                                            <span>{`${monthFake} meses`}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            <datalist id="ticks2">
                                <option value="3"></option>
                                <option value="6"></option>
                                <option value="9"></option>
                                <option value="12"></option>
                                <option value="24"></option>
                                <option value="36"></option>
                            </datalist>
                        </div>

                        <div className={style.indicator}>
                            <span aria-hidden="true">3 meses</span>
                            <span aria-hidden="true">36 meses</span>
                        </div>

                    </div>
                    <div>
                        {!touch && <>
                            <h5 aria-label="A sua prestação mensal" className={style.noTouchHeader}>
                                A sua <br /> prestação mensal:

                            </h5>
                            <img src={'/calculator2.svg'} alt='Illustration of three lightning bolts' />
                            <p>
                                Basta escolher
                                o montante que pretende financiar e o prazo.
                            </p>
                        </>}
                        {touch && <div className={style.touch}>
                            <h5 aria-label="A sua prestação mensal">
                                A sua <br /> prestação mensal:

                            </h5>
                            <div tabIndex={0} className={style.touch} aria-label={`${monthFake + 1} pagamentos de ${json[moneyFake][monthFake].cuotas} €`}>
                                <div aria-hidden="true">{monthFake + 1} pagamentos de</div>
                                <div aria-hidden="true">{json[moneyFake][monthFake].cuotas} €</div>
                            </div>
                            <div></div>
                            <div aria-label={`Total: ${parseFloat(parseFloat(moneyFake) + parseFloat(json[moneyFake][monthFake].intereses.replace(',', '.'))).toFixed(2).replace('.', ',')} €`} className={style.summary}>
                                <span aria-hidden="true">Total</span>
                                <span aria-hidden="true">{parseFloat(parseFloat(moneyFake) + parseFloat(json[moneyFake][monthFake].intereses.replace(',', '.'))).toFixed(2).replace('.', ',')} €</span>
                            </div>
                            <div aria-label={`TAEG: ${tae} %`} className={`${style.summary} ${style.last}`}>
                                <span aria-hidden="true">TAEG</span>
                                <span aria-hidden="true">{tae} %</span>
                            </div>
                            <div className={style.buttons}>
                                <button
                                    onClick={() => {
                                        props.close();
                                        navigate(data?.settings?.ctaUrlCalculator?.slug);

                                    }}
                                    className={`${style['button']} ${style['button--primary']}`}
                                >
                                    Ver lojas Aplazame
                                </button>

                            </div>
                        </div>}
                    </div>

                </div>

                <span role="text" aria-label={`Exemplo de financiamento com a APLAZAME para um cabaz de ${moneyFake}€ durante ${monthFake} meses, com pagamentos a partir de 30 dias após o envio do pedido. É necessário um depósito de ${json[moneyFake][monthFake].cuotas}€ que o utilizador deverá pagar com cartão no momento da compra. O valor a financiar é a diferença entre o cabaz e o depósito: ${parseFloat(moneyFake - parseFloat(json[moneyFake][monthFake].cuotas.replace(',', '.'))).toFixed(2).replace('.', ',')} €. São necessárias ${monthFake} prestações mensais de ${json[moneyFake][monthFake].cuotas} €. Taxa de abertura: 0,00 €. TAEG: ${tae}%. Valor total em dívida: ${parseFloat(parseFloat(json[moneyFake][monthFake].cuotas.replace(',', '.')) * monthFake).toFixed(2).replace('.', ',')} €: Sujeito à aprovação da APLAZAME.`} ref={wrapperFooter} className={style.footerText}>
                    Exemplo de financiamento com a APLAZAME para um cabaz de <strong aria-hidden="true">{moneyFake} €</strong> durante  <strong aria-hidden="true">{monthFake} meses</strong>, com pagamentos a partir de 30 dias após o envio do pedido. É necessário um depósito de <strong aria-hidden="true">{json[moneyFake][monthFake].cuotas} €</strong> que o utilizador deverá pagar com cartão no momento da compra. O <strong aria-hidden="true">valor a financiar</strong> é a diferença entre o cabaz e o depósito: <strong aria-hidden="true">{parseFloat(moneyFake - parseFloat(json[moneyFake][monthFake].cuotas.replace(',', '.'))).toFixed(2).replace('.', ',')} €</strong>. São necessárias <strong aria-hidden="true">{monthFake}</strong> prestações mensais de <strong aria-hidden="true">{json[moneyFake][monthFake].cuotas} €</strong>. Taxa de abertura: 0,00 €. TAEG: {tae}%. <strong aria-hidden="true">Valor total em dívida: {parseFloat(parseFloat(json[moneyFake][monthFake].cuotas.replace(',', '.')) * monthFake).toFixed(2).replace('.', ',')} €</strong>: Sujeito à aprovação da APLAZAME.
                </span>

            </div>

            <div
                className={`${style['embla__back']} ${style['embla__back--modal']}`}
            >
                <div>
                    <div className={style.form}>

                        <div ref={wrapperCalculateQuotasMobile}>
                            <Heading
                                tag={'h3'}
                                className={`${[style.headingSlide].join(' ')} ${style.back}`}
                            >
                                {_['calculator.heading']?.text}
                            </Heading>
                            <p dangerouslySetInnerHTML={{ __html: _['calculator.subheading']?.text }} className={style.headerText} />
                            <label>
                                <svg
                                    width="34"
                                    height="39"
                                    viewBox="0 0 34 39"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle cx="17" cy="19" r="17" fill="#231F20" />
                                    <path
                                        d="M16.5462 25V16.136L14.7062 16.568V15L17.4102 13.8H18.6742V25H16.5462Z"
                                        fill="white"
                                    />
                                </svg>
                                <span>Quanto pretende financiar?</span>
                            </label>

                            {/* <input aria-label={`Financiación ${moneyFake} €`} type='text' readOnly value={`${moneyFake} €`}></input> */}
                            <input aria-label={`Montante a financiar. O montante deve estar entre 100 e 2500 euros. Valor atual: ${moneyFake} €`} type='text' readOnly value={`${moneyFake} €`}></input>

                            <div className={`apz-input-range ${style["__range"]} ${style["__range-step"]}`}>
                                {/* <input
                                    onFocus={() => setMoneyFocus(true)}
                                    onBlur={() => setMoneyFocus(false)}
                                    aria-valuetext={
                                        { 1: "100 €", 2: "200 €", 3: "300 €", 4: "400 €", 5: "500 €", 6: "600 €", 7: "700 €", 8: "800 €", 9: "900 €", 10: "1000 €", 11: "1100 €", 12: "1200 €", 13: "1300 €", 14: "1400 €", 15: "1500 €", 16: "1600 €", 17: "1700 €", 18: "1800 €", 19: "1900 €", 20: "2000 €", 21: "2100 €", 22: "2200 €", 23: "2300 €", 24: "2400 €", 25: "2500 €" }[money]
                                    }
                                    aria-label="Cuánto quieres financiar" value={money} type="range" max="25" min="1" step="1" list="ticks1" onChange={(e) => {
                                        setTouch(true);
                                        const mappedValues = { 1: 100, 2: 200, 3: 300, 4: 400, 5: 500, 6: 600, 7: 700, 8: 800, 9: 900, 10: 1000, 11: 1100, 12: 1200, 13: 1300, 14: 1400, 15: 1500, 16: 1600, 17: 1700, 18: 1800, 19: 1900, 20: 2000, 21: 2100, 22: 2200, 23: 2300, 24: 2400, 25: 2500 };
                                        setMoneyFake(mappedValues[e.target.value]);
                                        setMoney(e.target.value);
                                    }}
                                /> */}
                                <input
                                    onFocus={() => setMoneyFocus(true)}
                                    onBlur={() => setMoneyFocus(false)}
                                    // aria-valuetext={
                                    //     { 1: "100 €", 2: "200 €", 3: "300 €", 4: "400 €", 5: "500 €", 6: "600 €", 7: "700 €", 8: "800 €", 9: "900 €", 10: "1000 €", 11: "1100 €", 12: "1200 €", 13: "1300 €", 14: "1400 €", 15: "1500 €", 16: "1600 €", 17: "1700 €", 18: "1800 €", 19: "1900 €", 20: "2000 €", 21: "2100 €", 22: "2200 €", 23: "2300 €", 24: "2400 €", 25: "2500 €" }[money]
                                    // }
                                    type="range"
                                    min="100"
                                    max="2500"
                                    step="100"
                                    value={money}
                                    aria-label={`Montante a financiar. O montante deve estar entre 100 e 2500 euros. Valor atual: ${moneyFake} €`}
                                    // max="25"
                                    // min="1"
                                    // step="1"
                                    aria-valuemin="100"
                                    aria-valuemax="2500"
                                    aria-valuenow={money}
                                    aria-valuetext={`Importe seleccionado: ${money} €`}

                                    list="ticks1" onChange={(e) => {
                                        setTouch(true);
                                        // const mappedValues = { 1: 100, 2: 200, 3: 300, 4: 400, 5: 500, 6: 600, 7: 700, 8: 800, 9: 900, 10: 1000, 11: 1100, 12: 1200, 13: 1300, 14: 1400, 15: 1500, 16: 1600, 17: 1700, 18: 1800, 19: 1900, 20: 2000, 21: 2100, 22: 2200, 23: 2300, 24: 2400, 25: 2500 };
                                        // setMoneyFake(mappedValues[e.target.value]);
                                        setMoneyFake(e.target.value);
                                        setMoney(e.target.value);
                                    }}
                                />
                                {moneyFocus &&
                                    <div className={style.rangeValueContainer}>
                                        <div className={style.rangeValueItem} style={{ left: `calc(${((money - 100) / 2400) * 100}% - ${35 + ((money - 100) / 2400) * 30}px)` }}>
                                            <div className={style.rangeLabel}>
                                                <span>{`${moneyFake} €`}</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <datalist id="ticks1">
                                    <option value="100"></option>
                                    <option value="200"></option>
                                    <option value="300"></option>
                                    <option value="400"></option>
                                    <option value="500"></option>
                                    <option value="600"></option>
                                    <option value="700"></option>
                                    <option value="800"></option>
                                    <option value="900"></option>
                                    <option value="1000"></option>
                                    <option value="1100"></option>
                                    <option value="1200"></option>
                                    <option value="1300"></option>
                                    <option value="1400"></option>
                                    <option value="1500"></option>
                                    <option value="1600"></option>
                                    <option value="1700"></option>
                                    <option value="1800"></option>
                                    <option value="1900"></option>
                                    <option value="2000"></option>
                                    <option value="2100"></option>
                                    <option value="2200"></option>
                                    <option value="2300"></option>
                                    <option value="2400"></option>
                                    <option value="2500"></option>
                                </datalist>
                            </div>

                            <div className={style.indicator}>
                                <span aria-hidden="true">100 €</span>
                                <span aria-hidden="true">2.500 €</span>
                            </div>

                            <div className={`${style.clearfix}`}></div>

                            <label className={style.separator}>
                                <svg
                                    width="34"
                                    height="39"
                                    viewBox="0 0 34 39"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle cx="17" cy="19" r="17" fill="#231F20" />
                                    <path
                                        d="M13.2457 25V23.512C13.9284 22.9467 14.5897 22.3867 15.2297 21.832C15.8804 21.2773 16.4564 20.728 16.9577 20.184C17.4697 19.64 17.875 19.112 18.1737 18.6C18.483 18.0773 18.6377 17.5707 18.6377 17.08C18.6377 16.6213 18.5097 16.216 18.2537 15.864C18.0084 15.512 17.5977 15.336 17.0217 15.336C16.435 15.336 15.9924 15.528 15.6937 15.912C15.395 16.296 15.2457 16.76 15.2457 17.304H13.2617C13.283 16.4827 13.4644 15.8 13.8057 15.256C14.147 14.7013 14.6004 14.2907 15.1657 14.024C15.731 13.7467 16.3657 13.608 17.0697 13.608C18.211 13.608 19.0964 13.9227 19.7257 14.552C20.3657 15.1707 20.6857 15.976 20.6857 16.968C20.6857 17.5867 20.5417 18.1893 20.2537 18.776C19.9764 19.3627 19.6084 19.928 19.1497 20.472C18.691 21.016 18.195 21.528 17.6617 22.008C17.1284 22.4773 16.611 22.9147 16.1097 23.32H20.9577V25H13.2457Z"
                                        fill="white"
                                    />
                                </svg>

                                <span>Durante quanto tempo:</span>
                            </label>

                            {/* <input aria-label={`Financiación a ${monthFake} meses`} className={style.inputMonths} type='text' readOnly value={`${monthFake} meses`}></input> */}
                            <input
                                aria-label={`Prazo selecionado: ${monthFake} meses. O prazo deve estar entre 3 e 36 meses.`}
                                className={style.inputMonths}
                                type='text'
                                readOnly
                                value={`${monthFake} meses`}></input>

                            <div className={`apz-input-range ${style["__range"]} ${style["__range-step"]}`}>
                                <input
                                    onFocus={() => setMonthFocus(true)}
                                    onBlur={() => setMonthFocus(false)}
                                    aria-label={`Duração do empréstimo. O prazo deve estar entre 3 e 36 meses. Valor atual: ${monthFake} meses.`}
                                    aria-valuemin="3"
                                    aria-valuemax="36"
                                    aria-valuenow={month}
                                    aria-valuetext={
                                        { 1: "Prazo selecionado: 3 meses", 2: "Prazo selecionado: 6 meses", 3: "Prazo selecionado: 9 meses", 4: "Prazo selecionado: 12 meses", 5: "Prazo selecionado: 24 meses", 6: "Prazo selecionado: 36 meses" }[month]
                                    }
                                    value={month}
                                    type="range"
                                    max="6"
                                    min="1"
                                    step="1"
                                    list="ticks2"
                                    onChange={(e) => {
                                        setTouch(true);
                                        const mappedValues = { 1: 3, 2: 6, 3: 9, 4: 12, 5: 24, 6: 36 };
                                        setMonthFake(mappedValues[e.target.value]);
                                        setMonth(e.target.value);
                                    }}
                                />
                                {/* <input
                                    onFocus={() => setMonthFocus(true)}
                                    onBlur={() => setMonthFocus(false)}
                                    aria-valuetext={
                                        { 1: "3 meses", 2: "6 meses", 3: "9 meses", 4: "12 meses", 5: "24 meses", 6: "36 meses" }[month]
                                    }
                                    aria-label="Durante cuánto tiempo" value={month} type="range" max="6" min="1" step="1" list="ticks1" onChange={(e) => {
                                        setTouch(true);
                                        const mappedValues = { 1: 3, 2: 6, 3: 9, 4: 12, 5: 24, 6: 36 };
                                        setMonthFake(mappedValues[e.target.value]);
                                        setMonth(e.target.value);
                                    }}
                                /> */}
                                {monthFocus &&
                                    <div className={style.rangeValueContainer}>
                                        <div className={style.rangeValueItem} style={{ left: `calc(${((month - 1) / 5) * 100}% - ${35 + ((month - 1) / 5) * 30}px)` }}>
                                            <div className={style.rangeLabel}>
                                                <span>{`${monthFake} meses`}</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <datalist id="ticks1">
                                    <option value="3"></option>
                                    <option value="6"></option>
                                    <option value="9"></option>
                                    <option value="12"></option>
                                    <option value="24"></option>
                                    <option value="36"></option>
                                </datalist>
                            </div>

                            <div className={style.indicator}>
                                <span aria-hidden="true">3 meses</span>
                                <span aria-hidden="true">36 meses</span>
                            </div>


                            <div
                                className={style.wrapperBtnMobileCalculate}
                            >
                                <button
                                    onClick={() =>
                                        tlRevealQuotasMobile.current.play()
                                    }
                                    className={`${style['button']} ${style['button--primary']}`}
                                >
                                    Calcular
                                </button>
                            </div>
                        </div>
                        <div
                            className={style.wrapperRevealQuotasMobile}
                            ref={wrapperRevealQuotasMobile}
                        >
                            <div className={style.wrapperQuotasMobile}>
                                <h4>A sua prestação mensal:</h4>
                                <div tabIndex={0} aria-label={`${monthFake + 1} pagamentos de ${json[moneyFake][monthFake].cuotas} €`}>
                                    <h5 aria-hidden="true">{monthFake + 1} pagamentos  de</h5>
                                    <div className={style.price} aria-hidden="true">{json[moneyFake][monthFake].cuotas} €</div>
                                </div>
                                <div aria-label={`Total: ${parseFloat(parseFloat(moneyFake) + parseFloat(json[moneyFake][monthFake].intereses.replace(',', '.'))).toFixed(2).replace('.', ',')} €`} className={style.summary}>
                                    <span aria-hidden="true">Total</span>
                                    <span aria-hidden="true">{parseFloat(parseFloat(moneyFake) + parseFloat(json[moneyFake][monthFake].intereses.replace(',', '.'))).toFixed(2).replace('.', ',')} €</span>
                                </div>
                                <div aria-label={`TAEG: ${tae} %`} className={style.summary}>
                                    <span aria-hidden="true">TAEG</span>
                                    <span aria-hidden="true">{tae} %</span>
                                </div>
                                <div className={style.buttons}>
                                    <button
                                        onClick={() => {
                                            navigate(data?.settings?.ctaUrlCalculator?.slug);

                                        }}
                                        className={`${style['button']} ${style['button--primary']}`}
                                    >
                                        Ver lojas Aplazame
                                    </button>
                                    <button
                                        onClick={() =>
                                            tlRevealQuotasMobile.current.reverse()
                                        }
                                        className={`${style['button']} ${style['button--secondary']}`}
                                    >
                                        Recalcular
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h5 aria-label="A sua prestação mensal">
                            A sua <br /> prestação mensal:

                        </h5>
                        <img src={'/calculator2.svg'} alt='Illustration of three lightning bolts' />
                        <p>
                            Basta escolher o montante que pretende financiar e o prazo.
                        </p>
                    </div>
                </div>

                <span role="text" aria-label={`Exemplo de financiamento com a APLAZAME para um cabaz de ${moneyFake}€ durante ${monthFake} meses, com pagamentos a partir de 30 dias após o envio do pedido. É necessário um depósito de ${json[moneyFake][monthFake].cuotas}€ que o utilizador deverá pagar com cartão no momento da compra. O valor a financiar é a diferença entre o cabaz e o depósito: ${parseFloat(moneyFake - parseFloat(json[moneyFake][monthFake].cuotas.replace(',', '.'))).toFixed(2).replace('.', ',')} €. São necessárias ${monthFake} prestações mensais de ${json[moneyFake][monthFake].cuotas} €. Taxa de abertura: 0,00 €. TAEG: ${tae}%. Valor total em dívida: ${parseFloat(parseFloat(json[moneyFake][monthFake].cuotas.replace(',', '.')) * monthFake).toFixed(2).replace('.', ',')} €: Sujeito à aprovação da APLAZAME.`} ref={wrapperFooter} className={style.footerText}>
                    Exemplo de financiamento com a APLAZAME para um cabaz de <strong aria-hidden="true">{moneyFake} €</strong> durante  <strong aria-hidden="true">{monthFake} meses</strong>, com pagamentos a partir de 30 dias após o envio do pedido. É necessário um depósito de <strong aria-hidden="true">{json[moneyFake][monthFake].cuotas} €</strong> que o utilizador deverá pagar com cartão no momento da compra. O <strong aria-hidden="true">valor a financiar</strong> é a diferença entre o cabaz e o depósito: <strong aria-hidden="true">{parseFloat(moneyFake - parseFloat(json[moneyFake][monthFake].cuotas.replace(',', '.'))).toFixed(2).replace('.', ',')} €</strong>. São necessárias <strong aria-hidden="true">{monthFake}</strong> prestações mensais de <strong aria-hidden="true">{json[moneyFake][monthFake].cuotas} €</strong>. Taxa de abertura: 0,00 €. TAEG: {tae}%. <strong aria-hidden="true">Valor total em dívida: {parseFloat(parseFloat(json[moneyFake][monthFake].cuotas.replace(',', '.')) * monthFake).toFixed(2).replace('.', ',')} €</strong>: Sujeito à aprovação da APLAZAME.
                </span>
            </div>
        </>
    )
}

export default Calculator
